<template>
  <div class="cnfltd-error-message">
    <a-alert
      :type="type"
      :message="title"
      :description="message"
      show-icon
      closable
      @close="handleClose"
    >
      <template v-if="showRetry" #action>
        <a-button size="small" type="primary" @click="handleRetry">
          Retry
        </a-button>
      </template>
    </a-alert>
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  title?: string
  message: string
  type?: 'error' | 'warning' | 'info'
  showRetry?: boolean
}

withDefaults(defineProps<Props>(), {
  title: 'Error',
  type: 'error',
  showRetry: false
})

// Emits
const emit = defineEmits<{
  retry: []
  close: []
}>()

const handleRetry = () => {
  emit('retry')
}

const handleClose = () => {
  emit('close')
}
</script>

<style scoped>
.cnfltd-error-message {
  margin: 1.5rem 0;
}
</style>
